<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Nº do Convênio" :xl="xl">
                    <strong>{{ convenio.vcCodigoEstruturado }}</strong>
                </app-detalhe>
                <!--app-detalhe titulo="Ata Direx" :xl="xl">
                    <strong> {{/*convenio.processoAta.ataDirex.nuAtaDirex*/}} </strong>
                </app-detalhe-->
                <app-detalhe titulo="Nº do Processo" :xl="xl">
                    <span v-if="convenio.processoAta">
                        <strong>
                        {{convenio.processoAta.nuProcesso}}
                        </strong>
                    </span>
                </app-detalhe>
                <app-detalhe titulo="Objeto" :xl="xl">
                    <strong>{{ convenio.vcObjeto }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Convenente" :xl="xl">
                    <span v-if="convenio.convenenteRM">
                        <strong>
                            {{ convenio.convenenteRM.cnpj }} |
                            {{ convenio.convenenteRM.nome }}
                        </strong>
                    </span>
                </app-detalhe>
            </b-col>
            <b-col>
                <app-detalhe titulo="Valor Total Convênio" :xl="xl">
                    <strong>{{ convenio.nuValorConvenio | currency }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Receita Prevista" :xl="xl">
                    <strong>{{ convenio.nuValorReceitaPrevista | currency }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Rendimentos" :xl="xl">
                    <strong>{{ convenio.totalRendimentos | currency }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Receitas" :xl="xl">
                    <strong>{{ convenio.totalReceitas | currency }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Vigência" :xl="xl">
                    <strong> {{ convenio.dtInicioVigencia ? $moment(convenio.dtInicioVigencia).format('DD/MM/YYYY') : '' }}
                        a
                        {{ convenio.dtFimVigencia ? $moment(convenio.dtFimVigencia).format('DD/MM/YYYY') : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Gestor" :xl="xl">
                    <span v-if="convenio.gestor">
                        <strong>
                            {{ convenio.gestor.codNomeFuncionario }}
                        </strong>
                    </span>
                </app-detalhe>
                <app-detalhe titulo="Unidade" :xl="xl">
                    <span v-if="convenio.unidade">
                        <strong>{{ convenio.unidade.nome }}
                        </strong>
                    </span>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        convenio: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 3,
            showModal: false
        }
    }
}
</script>
